<div class="fees-item-wrapper">

  <div class="fees-item-header">
    <h2>Add Fee Item</h2>
    <p>Create and manage school fee structures</p>
  </div>

  <div class="fees-item-card">

    <form (ngSubmit)="submitForm()">

      <!-- Row 1: Fee Label + Amount -->
      <div class="fees-form-row">

        <div class="fees-form-group">
          <label>Fee Label</label>
          <input type="text" [(ngModel)]="form.label" name="label" placeholder="e.g. Tuition Fee" required>
        </div>

        <div class="fees-form-group">
          <label>Amount (₵)</label>
          <input type="number" [(ngModel)]="form.amount" name="amount" placeholder="0.00" required>
        </div>

      </div>

      <!-- Row 2: Student Type + Academic Year -->
      <div class="fees-form-row">

        <!-- STUDENT TYPE (Single Select Chip) -->
        <div class="fees-form-group">
          <div class="fees-chip-select">

            <label>Student Type *</label>

            <div class="chip-box" (click)="toggleStudentDropdown()">

              <ng-container *ngIf="selectedStudentType; else studentPlaceholder">
                <span class="chip single">
                  {{ selectedStudentType.label }}
                  <span class="remove" (click)="clearStudentType($event)">×</span>
                </span>
              </ng-container>

              <ng-template #studentPlaceholder>
                <span class="placeholder">Select student type</span>
              </ng-template>

              <span class="arrow" [class.open]="studentDropdownOpen">⌄</span>
            </div>

            <div class="dropdown" *ngIf="studentDropdownOpen">
              <div
                class="option"
                *ngFor="let s of studentTypes"
                (click)="selectStudentType(s)">
                {{ s.label }}
                <span *ngIf="selectedStudentType?.value === s.value">✓</span>
              </div>
            </div>

          </div>
        </div>

        <!-- ACADEMIC YEAR (Single Select Chip) -->
        <div class="fees-form-group">
          <div class="fees-chip-select">

            <label>Academic Year *</label>

            <div class="chip-box" (click)="toggleYearDropdown()">

              <ng-container *ngIf="selectedAcademicYear; else yearPlaceholder">
                <span class="chip single">
                  {{ selectedAcademicYear.label }}
                  <span class="remove" (click)="clearAcademicYear($event)">×</span>
                </span>
              </ng-container>

              <ng-template #yearPlaceholder>
                <span class="placeholder">Select academic year</span>
              </ng-template>

              <span class="arrow" [class.open]="yearDropdownOpen">⌄</span>
            </div>

            <div class="dropdown" *ngIf="yearDropdownOpen">
              <div
                class="option"
                *ngFor="let y of academicYears"
                (click)="selectAcademicYear(y)">
                {{ y.label }}
                <span *ngIf="selectedAcademicYear?.value === y.value">✓</span>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- Row 3: Semester (Multi Select Chip) -->
      <div class="fees-form-row">

        <div class="fees-form-group">
          <div class="fees-chip-select">

            <label>Semester *</label>

            <div class="chip-box" (click)="toggleDropdown()">

              <ng-container *ngIf="selectedSemesters.length > 0; else semPlaceholder">
                <span class="chip" *ngFor="let s of selectedSemesters">
                  {{ s.label }}
                  <span class="remove" (click)="removeSemester(s, $event)">×</span>
                </span>
              </ng-container>

              <ng-template #semPlaceholder>
                <span class="placeholder">Select semester</span>
              </ng-template>

              <span class="arrow" [class.open]="dropdownOpen">⌄</span>
            </div>

            <div class="dropdown" *ngIf="dropdownOpen">
              <div
                class="option"
                *ngFor="let s of semesters"
                (click)="toggleSemester(s)">
                {{ s.label }}
                <span *ngIf="isSelected(s)">✓</span>
              </div>
            </div>

          </div>
        </div>

      </div>

      <!-- Actions -->
      <div class="fees-form-actions">
        <button type="button" class="btn-secondary" (click)="resetForm()">Reset</button>
        <button type="submit" class="btn-primary" [disabled]="loading">
          {{ loading ? 'Saving...' : 'Save Fee Item' }}
        </button>
      </div>

    </form>

  </div>

  <app-retreivefeeitems></app-retreivefeeitems>

</div>